import { render, staticRenderFns } from "./ExhibitionSearchDetail.vue?vue&type=template&id=06bef498&"
import script from "./ExhibitionSearchDetail.vue?vue&type=script&lang=js&"
export * from "./ExhibitionSearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionSearchDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports